export const bantTexts = {
  title: 'BANT Methodology',
  description: `The BANT methodology plugin seamlessly integrates essential fields into your environment, acting as checkpoints between stages you define for a structured qualification process. Already using BANT fields? No worries! Our field mapper effortlessly aligns Sweep's fields with your existing ones, ensuring a smooth transition.`,
};
